module.exports = __webpack_public_path__ + "img/koreainvestment.329a33ec.png";